import React from 'react'

function Reports() {
    return (
        <div class="idocs-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <section id="idocs_content">
                            <h2>Reports</h2>
                            <hr />
                            <p>
                            Documentation and examples for opt-in styling of tables.
                            </p>
                        </section>
                        
                    </div>
                    <div class="col-md-4 extreme-rt-div">
                        
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Reports